//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../axios/axios.js'
import RequestRoadsBody from './RequestRoadsBody.vue'
import RequestRoadsButtons from './RequestRoadsButtons.vue'
import FilesGroup from '../../components/File/FilesGroup.js'

export default {
  components: {
    RequestRoadsBody,
    RequestRoadsButtons
  },
  props: {
    request: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      changes: []
    }
  },
  created: async function () {
    this.convertComments()
    this.changes = []

    this.prepareFiles()
  },
  methods: {
    prepareFiles: function () {
      const requestRoads = this.request.requestRoads
      if (!requestRoads) {
        return
      }

      this.$set(requestRoads, '_filesGroupImagesBefore', null)
      this.$set(requestRoads, '_filesGroupAttachmentBefore', null)

      requestRoads._filesGroupImagesBefore = new FilesGroup({
        key: 'requestRoadsImagesBefore',
        categoryKey: 'requestRoadsImagesBefore',
        readonly: !this.roadsCommandType,
        sourceConfig: {
          objectId: requestRoads.id,
          uploadURL: '/service/delta/document/upload',
          removeURL: '/service/delta/document/deleteFromObject'
        }
      })
      requestRoads._filesGroupAttachmentBefore = new FilesGroup({
        key: 'requestRoadsAttachmentBefore',
        categoryKey: 'requestRoadsAttachmentBefore',
        readonly: !this.roadsCommandType,
        sourceConfig: {
          objectId: requestRoads.id,
          uploadURL: '/service/delta/document/upload',
          removeURL: '/service/delta/document/deleteFromObject'
        }
      })

      if (requestRoads.roadsFileData && requestRoads.roadsFileData.length) {
        requestRoads.roadsFileData.forEach(file => {
          if (file.roadsFileType === 'imagesBefore') {
            requestRoads._filesGroupImagesBefore.pushFiles(file)
          } else if (file.roadsFileType === 'attachmentBefore') {
            requestRoads._filesGroupAttachmentBefore.pushFiles(file)
          }
        })
      }
    },
    convertComments: function () {
      if (this.request.requestRoads.comments) {
        this.request.requestRoads.comments = this.request.requestRoads.comments.map(comment => {
          let status = ''
          let color = ''
          if (comment.assetState === 3) {
            status = 'Не работает'
            color = 'red'
          } else if (comment.assetState === 1) {
            status = 'Работает'
            color = 'green'
          } else if (comment.assetState === 2) {
            status = 'Работает с замечаниями'
            color = 'orange'
          } else if (comment.assetState === 4) {
            status = 'Регламентные работы'
            color = 'black'
          }
          return {
            fio: comment.authorName,
            comment: comment.content,
            time: comment.create,
            status: status,
            color: color
          }
        })
      } else {
        this.request.requestRoads.comments = []
      }
    },
    onClose: function () {
      this.$emit('cancel')
    },
    actualize: function (highlightChanges) {
      this.changes = []

      const data = {
        requestId: this.request.requestId
      }

      return axiosPost({
        url: '/vis/updateRequestV5/update',
        data: data,
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: (response) => {
          if (highlightChanges) {
            this.changes = response.data.changes
          }
        },
        // onFailure: (response) => {
        //   this.changes = ['comments', 'createDate', 'senderName', 'geopoint']
        // }
        onFailure: 'Ошибка актуализации данных по заявке'
      }).finally((response) => {
        this.$q.loading.hide()
      })
    },
    onUpdate: async function (highlightChanges = false) {
      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      await this.actualize(highlightChanges)

      return axiosGet({
        url: '/service/delta/request/getRequest?id=' + this.request.requestId,
        onSuccess: (response) => {
          const request = response.data.result

          this.request.exportImportStatus = request.exportImportStatus
          this.request.statusVis = request.statusVis
          this.request.requestRoads = request.roadsRequestData
          this.convertComments()
        },
        onFailure: 'Ошибка получения данных по заявке'
      }).finally(() => {
        // Чтобы после закрытия модального окна данные заявки обновились
        this.$emit('update')

        this.$q.loading.hide()
      })
    }
  }
}

